import React from "react";
import { Link } from "react-router-dom";
import "../static/dashboard-ipad.css";

const dateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const sortByHour = (items) =>
  [...items].sort((a, b) =>
    String(a.hour || "99:99").localeCompare(String(b.hour || "99:99"))
  );

const getMonthGridDays = (visibleMonth) => {
  const firstDay = new Date(
    visibleMonth.getFullYear(),
    visibleMonth.getMonth(),
    1
  );

  const mondayOffset = (firstDay.getDay() + 6) % 7;
  const gridStart = new Date(
    visibleMonth.getFullYear(),
    visibleMonth.getMonth(),
    1 - mondayOffset
  );

  return Array.from({ length: 42 }, (_, index) => {
    const day = new Date(gridStart);
    day.setDate(gridStart.getDate() + index);
    return day;
  });
};

const eventClassName = (item) => {
  if (item.source === "quick") return "is-quick";
  if (item.behaviour === "Aggressive") return "is-alert";
  if (item.catordog === "Cat") return "is-cat";
  if (item.catordog === "Dog") return "is-dog";
  return "is-default";
};

const MonthlyCalendarBoard = ({
  visibleMonth,
  events,
  onPreviousMonth,
  onNextMonth,
  onToday,
  onEdit,
  onDelete,
}) => {
  const monthDays = getMonthGridDays(visibleMonth);
  const today = dateKey(new Date());

  const monthTitle = visibleMonth.toLocaleDateString("en-GB", {
    month: "long",
    year: "numeric",
  });

  return (
    <section className="ipad-month-calendar">
      <header className="ipad-calendar-head">
        <div>
          <span className="ipad-calendar-kicker">Monthly planner</span>
          <h2>{monthTitle}</h2>
          <p>Appointments are grouped by day and sorted by time.</p>
        </div>

        <div className="ipad-calendar-controls">
          <button type="button" onClick={onPreviousMonth}>
            ← Previous
          </button>

          <button type="button" onClick={onToday}>
            Today
          </button>

          <button type="button" className="primary" onClick={onNextMonth}>
            Next →
          </button>
        </div>
      </header>

      <div className="ipad-month-scroll">
        <div className="ipad-month-grid">
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
            <div className="ipad-month-weekday" key={day}>
              {day}
            </div>
          ))}

          {monthDays.map((dateObject) => {
            const currentDateKey = dateKey(dateObject);
            const isCurrentMonth =
              dateObject.getMonth() === visibleMonth.getMonth();

            const dayEvents = sortByHour(
              events.filter((item) => item.datee === currentDateKey)
            );

            return (
              <article
                className={`ipad-month-day ${
                  !isCurrentMonth ? "is-outside" : ""
                } ${currentDateKey === today ? "is-today" : ""}`}
                key={currentDateKey}
              >
                <header className="ipad-month-day-head">
                  <strong>{dateObject.getDate()}</strong>
                  {dayEvents.length > 0 && (
                    <span>{dayEvents.length}</span>
                  )}
                </header>

                <div className="ipad-month-events">
                  {dayEvents.map((item) => (
                    <article
                      className={`ipad-event-card ${eventClassName(item)}`}
                      key={`${item.source || "grooming"}-${item.id}`}
                    >
                      <div className="ipad-event-time">
                        {item.hour || "Time pending"}
                      </div>

                      <div className="ipad-event-content">
                        <strong>{item.petname || "Pet name pending"}</strong>
                        <span>
                          {item.ownername || item.phone || "Owner pending"}
                        </span>
                        <small>
                          {item.source === "quick"
                            ? "Profile pending"
                            : item.catordog || "Appointment"}
                        </small>
                      </div>

                      <div className="ipad-event-actions">
                        <button
                          type="button"
                          className="edit"
                          onClick={() => onEdit(item)}
                        >
                          {item.source === "quick" ? "Complete" : "Edit"}
                        </button>

                        <button
                          type="button"
                          className="delete"
                          onClick={() => onDelete(item)}
                        >
                          Delete
                        </button>
                      </div>
                    </article>
                  ))}
                </div>

                <Link
                  className="ipad-add-button"
                  to={`/add-appointment?date=${currentDateKey}`}
                >
                  + Add
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MonthlyCalendarBoard;
